import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Layout, Button, message, Divider } from "antd";
import { URL } from "../00_Nav/url";
import LayoutFooter from "../00_Nav/layout/layout_footer";
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import UserDetail from "./component/user_detail";
import UserList from "./component/user_list";
import UserControl from "./component/user_control";
import { useDispatch } from "react-redux";
import { snapAllUsers, unSnapUsers } from "../../store/user/user.action";
import { useSelector } from "react-redux";
import { allSelector, usersSelector } from "../../store/user/user.selector";

const { Content } = Layout;
const UserScreen = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Users", url: URL.user },
  ];
  // -------------------------- STATE --------------------------
  const [detail, setDetail] = useState(null);
  const [add, setAdd] = useState(false);
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const allUsers = useSelector(usersSelector);
  // -------------------------- FUNCTION --------------------------
  const onSearch = (e) => {
    setSearch(e.target.value);
  };
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    dispatch(snapAllUsers());
    return () => dispatch(unSnapUsers());
  }, [dispatch]);

  // search
  useEffect(() => {
    if (search === "") {
      setData(allUsers);
    } else {
      const lowerSearch = search.toLowerCase();
      const filterData = allUsers?.filter((user) => {
        const combine = `${user?.username}${user?.firstName} ${user?.lastName}${user?.phone}${user?.email}`;
        const lowerCombine = combine.toLocaleLowerCase();
        const included = lowerCombine?.includes(lowerSearch);
        return included;
      });
      setData(filterData);
    }
  }, [search, allUsers]);
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Col span={24}>
        <Row gutter={[20, 20]}>
          <UserDetail
            detail={detail}
            setDetail={setDetail}
            add={add}
            setAdd={setAdd}
          />
          <Divider style={{ marginBottom: 0 }} />
          <UserControl setAdd={setAdd} data={data} onSearch={onSearch} />
          <UserList data={data} setDetail={setDetail} />
        </Row>
      </Col>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {renderBody()}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};
export default UserScreen;
